import type { PersonalFinanceEnvironment } from '../types';
import { getCookieContent } from './cookies';

export default function getLowAssuranceCookie(
  environment: PersonalFinanceEnvironment,
): string {
  const cookieName = environment === 'Prod' ? 'Kmx_LP' : 'Kmx_LQ';
  return getCookieContent(cookieName) ?? '';
}
